import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import Vue from "vue";

const ServiceRepository = RepositoryFactory.get('services');

const state = {
    selectedPublisher: [],
    selectedSite: null,
    sites: [],
    loading: {
        submit: false,
        deploy: false,
        config: false
    },
    videoConfig: null,
    previousSiteId: null,
    activeSiteId: null,
}
const getters = {}
const actions = {
    async fetchVideo({state, commit}, payload) {
        state.loading.config = true;
        let {data} = await ServiceRepository.getVideo(payload);
        if (data.Status) {
            commit('setVideoConfig', data)
        }
        state.loading.config = false;
        return data;
    },
    async editVideo({state}, payload) {
        let json = payload.data;
        state.loading.submit = true;
        let {data} = await ServiceRepository.editVideo(payload.previousSiteId ? state.previousSiteId : json.site_id, json);
        if (data.Status) {
            if (!payload.previousSiteId) {
                let videoConfig = JSON.parse(JSON.stringify(state.videoConfig.Video));
                videoConfig.KidSecure = json.kidSecure;
                videoConfig.Consent = json.consent;
                videoConfig.IsMediaImpact = json.mediaImpact;
                videoConfig.IsSingleSpotAllowed = json.singleSpot;
                Vue.set(state.videoConfig, 'Video', videoConfig);
            }
        }
        state.loading.submit = false;
        return data;
    },
    async deployVideo({state}, payload) {
        state.loading.deploy = true;
        let {data} = await ServiceRepository.deployVideo(payload.site_id, payload);
        state.loading.deploy = false;
        return data;
    },
}
const mutations = {
    updateSelectedPublisher(state, {data}) {
        state.selectedPublisher = data;
    },
    setVideoConfig(state, data) {
        state.videoConfig = data;
    },
    setSites(state, {data}) {
        state.sites = data;
    },
    setSelectedSite(state, data) {
        state.selectedSite = data;
    },
    updateActiveSiteId(state, payload) {
        if (state.activeSiteId !== null) {
            state.previousSiteId = state.activeSiteId;
        }
        state.activeSiteId = payload;
    },
}


export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}